import React from 'react';

const projects = [
  {
    img: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=1000&q=80',
    alt: 'FinanceHub trading dashboard with real-time analytics',
    tag: 'Fintech · Web + Mobile',
    title: 'FinanceHub Trading Platform',
    desc: 'Real-time trading dashboard with AI-powered portfolio recommendations, serving 100K+ daily active users across web and mobile.',
    size: 'folio-large',
    titleSize: '1.5rem',
    delay: 'rv-d1',
  },
  {
    img: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=600&q=80',
    alt: 'RetailMax e-commerce platform',
    tag: 'E-Commerce · Platform',
    title: 'RetailMax',
    desc: 'Premium e-commerce engine with AI-driven personalization and 40% conversion uplift.',
    size: 'folio-small',
    titleSize: '1.25rem',
    delay: 'rv-d2',
  },
  {
    img: 'https://images.unsplash.com/photo-1558494949-ef010cbdcc31?w=600&q=80',
    alt: 'CloudNine infrastructure monitoring dashboard',
    tag: 'Cloud · DevOps',
    title: 'CloudNine Monitoring',
    desc: 'Real-time infrastructure monitoring with intelligent auto-scaling and alerting.',
    size: 'folio-bottom',
    titleSize: '1.25rem',
    delay: 'rv-d3',
  },
  {
    img: 'https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?w=600&q=80',
    alt: 'HealthFirst telehealth application',
    tag: 'Healthcare · Mobile',
    title: 'HealthFirst',
    desc: 'HIPAA-compliant telehealth platform connecting 50K+ patients with providers.',
    size: 'folio-bottom',
    titleSize: '1.25rem',
    delay: 'rv-d4',
  },
  {
    img: 'https://images.unsplash.com/photo-1535378917042-10a22c95931a?w=600&q=80',
    alt: 'EduLearn AI tutoring platform',
    tag: 'EdTech · AI',
    title: 'EduLearn AI Tutor',
    desc: 'Adaptive learning platform with personalized AI tutoring and progress analytics.',
    size: 'folio-bottom',
    titleSize: '1.25rem',
    delay: 'rv-d5',
  },
];

function Portfolio() {
  return (
    <section id="work" className="section">
      <div className="section-inner">
        <div className="folio-header">
          <div className="rv">
            <span className="label-tag" style={{ marginBottom: '1.5rem', display: 'block' }}>Selected Work</span>
            <h2 className="section-title">Projects that<br />speak for themselves</h2>
          </div>
          <div className="rv rv-d2">
            <a href="#contact" className="btn-ghost">
              View All Work <i className="fa-solid fa-arrow-right" style={{ fontSize: '0.75rem' }}></i>
            </a>
          </div>
        </div>

        <div className="folio-grid">
          {projects.map((proj, i) => (
            <div key={i} className={`folio-card ${proj.size} rv ${proj.delay}`}>
              <img src={proj.img} alt={proj.alt} />
              <div className="folio-overlay">
                <span className="folio-tag">{proj.tag}</span>
                <h3 style={{ fontSize: proj.titleSize, fontWeight: 700 }}>{proj.title}</h3>
                <p style={{ maxWidth: proj.size === 'folio-large' ? '28rem' : undefined }}>{proj.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Portfolio;
